

export const fiatCurrencies = [
    { name: 'USD', symbol: '$' },
    { name: 'EUR', symbol: '€' },
    { name: 'JPY', symbol: '¥' }
]

export const displayModes = [
  { name: 'Price', priceAlias: 'PRICE', amountAlias: 'AMOUNT' },
  { name: 'Odds', priceAlias: 'ODDS', amountAlias: 'STAKE' }
]

export const pricedTokens = [
  "GBYTE",
  "AE",
  "BAT",
  "BNB",
  "DAI",
  "KNC",
  "LOOM",
  "LRC",
  "MITH",
  "MKR",
  "NPXS",
  "OMG",
  "PRFT",
  "REP",
  "SNT",
  "WTC",
  "ZRX",
  "USDC",
  "BTC",
]



// WEBPACK FOOTER //
// ./src/config/index.js